<template>
    <div v-if="show" class="search-ms frame-padding">
        <div class="search-ms__panel">
            <div class="ms__logo">
                <router-link to="/"> 
                    <img src="../../assets/logo.svg" alt="">
                    <!-- <span>МОСП</span>  -->
                </router-link>
            </div>
            <input-ms placeholder="Поиск" @click="setSearch"></input-ms>
            <div class="search-ms__adress">
                <p>{{ adress }}</p>
            </div>
            <router-link class="search-mini__link" to="searchMs"><icon-ms name="search"></icon-ms></router-link>
            <button-ms @click="isRecord = !isRecord">Записаться на прием</button-ms>
        </div>
    </div>
    <modal-form-ms class="record__modal" v-if="isRecord" > 
        <h2>Записаться на прием</h2>
        <button @click="isRecord = false" class="close"></button>
        <div v-html="body" class="panel"> 
        </div>
    </modal-form-ms>
</template>
<script>
import iconMs from '../common/iconMs.vue';
import inputMs from '../common/inputMs.vue';
import buttonMs from '../common/buttonMs.vue';
import modalFormMs from '../common/modalFormMs.vue';
// import panelMs from '../common/panelMs.vue';
import axios from 'axios';
export default{
    components:{
        iconMs,
        inputMs,
        buttonMs,
        modalFormMs,
        // panelMs,
    },
    watch:{
        showRecord(){
            this.isRecord = true
        }
    },
    mounted(){
        axios
            .get('https://mosp51.ru/api/doc?id=7')
            .then(response=>{
                this.body = response.data.body
            })
    },
    methods:{
        setSearch(text){
            if (text != ''){
                 this.$router.push({
                    path: '/searchMs',
                    name: 'Поиск',
                    query: {
                        text: text
                    }
                });
            }
        }
    },
    props:['adress', 'showRecord','show' ],
    data(){
        return{
            body:'',
            isRecord:false
        }
    }
}
</script>
<style>
    .search-mini__link{
        display: none;
    }
    .search-ms .search-ms__panel{
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: space-between;
    }
    .header .record__modal .modal-form {
        padding:64px;
        width:100%;
        max-width: 1193px;
        height: 426px;
        border-radius: 10px;
    }
     .header .record__modal .modal-form h3,
     .header .record__modal .modal-form h2{
        font-weight: 500;
        font-style: Medium;
        font-size: 32px;
        line-height: 100%;
        color: #0D3041;
    }
    .header .record__modal .modal-form h2{
        margin-bottom: -8px;
    }
    .header .record__modal .modal-form h3{
        font-size: 22px;
        margin: 32px 0 8px 0;
    }
    .header .record__modal .modal-form .panel{
        background-color: transparent;
    }
    .header .record__modal .modal-form .panel li,
    .header .record__modal .modal-form .panel a,
    .header .record__modal .modal-form .panel p{
        font-size: 16px;
    }
    .header .modal-form .close{
        border:none;
        background-color: transparent;
        position: absolute;
        right: 64px;
        top: 64px;
        width: 30px;
        height: 30px;
        cursor: pointer;
    }   
    .header .modal-form .close::before,
    .header .modal-form .close::after{
        content: '';
        position: absolute;
        border: 1px solid #175472;
        display: block;
        width: 20px ;
        border-radius: 10px;
        transform: rotate(45deg);
    }
    .header .modal-form .close::before{
        transform: rotate(-45deg);
    }
@media (max-width: 1220px){
    .search-ms__panel .search-ms__adress{
        display: none;
    }
}
@media (max-width: 1000px){
    .search-ms__panel .search-ms__panel_button,
    .search-ms__panel .search-ms___panel_input{
        display: none;
    }
    .search-ms .search-ms__panel{
        padding:16px 24px;
    }
    .search-ms .search-ms__panel .ms__logo{
       margin-left: 44px;
    }
    .search-mini__link{
        display: flex;
        align-items: center;
    }
    .header .record__modal .modal-form{
        padding:24px;
        margin-left: 20px;
        margin-right: 20px;
        height: 435px;
    }
    .header .record__modal .modal-form h2{
        font-size: 22px;
    }
    .header .record__modal .modal-form h3{
        font-size: 16px;
    }
    .header .modal-form .close{
        right: 10px;
        top: 20px;
    }
    .header .modal-form .close::before, 
    .header .modal-form .close::after{
        width: 13px;
    }


}
</style>